import React from 'react';
import C3Chart from './c3chart';
import PropTypes from 'prop-types';
/* Styles */
import './gauge.scss';
import 'c3/c3.css';

class Gauge extends React.PureComponent {
  constructor(props) {
    super(props);
    this.parentRef = React.createRef();
    this.state = {
      dataTitle: this.props.gaugeData.label,
      dataColumn: [[this.props.gaugeData.label, this.props.gaugeData.total]],
      parentHeight: this.props.parentHeight,
      max: this.props.max,
      legend: {
        show: false,
      },
      padding: {
        bottom: 40,
      },
    };
    this.c3Chart = React.createRef();
  }

  componentDidMount() {
    const textNode = this.c3Chart.current.chart.element.querySelector(
      'text[class="c3-gauge-value"]'
    );
    this.c3Chart.current.chart.internal.d3.select(textNode).attr('dy', '-.65em');
    this.c3Chart.current.chart.internal.d3
      .select(textNode.parentElement)
      .append('text')
      .attr('class', 'c3-gauge-value-sub-title')
      .attr('dy', '.2em')
      .style('font-size', `${this.props.parentHeight / 25}px`)
      .text(this.state.dataTitle);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.parentHeight !== this.props.parentHeight ||
      prevProps.parentWidth !== this.props.parentWidth
    ) {
      this.handleResize();
      this.handleSubTitleResize();
    }
    if (prevProps.gaugeData.label !== this.props.gaugeData.label) {
      this.handleDataChange();
      this.handleResize();
    }
  }

  handleResize = () => {
    this.setState({
      parentHeight: this.props.parentHeight,
    });
    this.c3Chart.current.chart.resize({height: this.state.parentHeight / 1.5, width: null});
  };

  handleSubTitleResize = () => {
    const textNode = this.c3Chart.current.chart.element.querySelector(
      'text[class="c3-gauge-value-sub-title"]'
    );
    this.c3Chart.current.chart.internal.d3
      .select(textNode)
      .style('font-size', `${this.props.parentHeight / 25}px`);
  };

  handleDataChange = () => {
    this.setState({
      ...this.state,
      dataTitle: this.props.gaugeData.label,
      dataNumber: this.props.filteredData,
      max: this.props.max,
    });
  };

  handleValuesUpdate = () => {
    this.setState({
      ...this.setState,
      dataNumber: this.props.filteredData,
      max: this.props.max,
    });
  };

  render() {
    return (
      <>
        <div className="gauge" ref={this.parentRef} id="gauge__container">
          <C3Chart
            ref={this.c3Chart}
            onPropsChanged={(props, chart) => {
              chart.internal.config.gauge_max = props.gauge.max;
            }}
            gauge={{
              label: {
                show: this.props.max,
                format: (value) => {
                  return `${value}`;
                },
              },
              expand: false,
              max: this.props.max ? this.props.max : 1,
            }}
            data={{
              onclick: () => {
                if (typeof this.props.goToSolution === 'function') {
                  this.props.goToSolution();
                }
              },
              columns: [[this.state.dataTitle, this.props.filteredData]],
              type: 'gauge',
              colors: {
                [this.state.dataTitle]: '#3CC8D1',
              },
            }}
            padding={this.state.padding}
            size={{height: this.state.parentHeight / 1.5}}
            tooltip={{
              contents: (d) => {
                const tooltip = `<div class="gauge-tooltip">
                                                    <span class="gauge-tooltip--bold">
                                                        ${d[0].value}
                                                    </span>
                                                        ${d[0].name}
                                                <div>`;
                return tooltip;
              },
            }}
            legend={this.state.legend}
          />
        </div>
      </>
    );
  }
}

Gauge.propTypes = {
  parentHeight: PropTypes.number.isRequired,
  parentWidth: PropTypes.number.isRequired,
  gaugeData: PropTypes.objectOf(PropTypes.any).isRequired,
  filteredData: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  goToSolution: PropTypes.func,
};

Gauge.defaultProps = {
  goToSolution: null,
};

export default Gauge;
